module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edmodo-footer-column fl"
  }, [_c('h4', {
    staticClass: "widget-title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('nav', [_c('ul', _vm._l((_vm.links), function(link, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": link.url + (_vm.lang ? ('?lang=' + _vm.lang) : ''),
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.eventTracking(link)
        }
      }
    }, [_c('span', {
      staticClass: "link-text",
      domProps: {
        "textContent": _vm._s(link.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "arrow"
    })])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d32ca986"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edmodo/footer/column.vue
// module id = 468
// module chunks = 9